import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Header from './Header';
import Disconnect from './Disconnect';
import Container, { ModalMenu } from './styles';

const AvatarModal = ({
  className,
  isModalOpen,
  toggleModal,
  informations,
  logout,
}) => {
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isModalOpen]);

  return (
    <Container className={className} isModalOpen={isModalOpen}>
      <ModalMenu>
        <Header informations={informations} toggleModal={toggleModal} />
        <Disconnect toggleModal={toggleModal} logout={logout} />
      </ModalMenu>
    </Container>
  );
};

AvatarModal.propTypes = {
  className: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  informations: PropTypes.shape({
    discord: PropTypes.shape({
      username: PropTypes.string.isRequired,
      discriminator: PropTypes.string.isRequired,
    }),
  }).isRequired,
  logout: PropTypes.func.isRequired,
};

export default styled(AvatarModal)`
  .settingsButton {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    width: 2rem;
    height: 2rem;
    margin: 0.5rem;
  }
`;
